import PublicLayout from '../components/layouts/PublicLayout';
import { Container, Row, Col, Button, FormGroup, Input } from 'reactstrap';
import {useState, useEffect} from 'react';
import { Form} from "react-bootstrap";
import Select from 'react-select';
import {ContactTypes, ContactUsEndpoint} from '../lib/Endpoints'
import axios from 'axios';
import Head from 'next/head';
import { useRouter } from 'next/router'

function ContactUs({meta}) {
    const router = useRouter();
	const [loading, setLoading] = useState(false); 
	const [contactTypes, setContactType] = useState([]);
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [email, setEmail] = useState("");
	const [companyName, setCompanyName] = useState("");
	const [message, setMessage] = useState("");
	const [type, setType] = useState("");
	const [phone, setPhone] = useState("");
	const [error, setError] = useState("");

	//validation states
	const [firstNameErr, setFirstNameErr] = useState("");
	const [lastNameErr, setLastNameErr] = useState("");
	const [companyNameErr, setCompanyNameErr] = useState("");
	const [emailErr, setEmailErr] = useState("");
	const [phoneErr, setPhoneErr] = useState("");
	const [typeErr, setTypeErr] = useState("");
	const [messageErr, setMessageErr] = useState("");

	const getContactTypeRequestApi = () => {
        setLoading(true);
        const headers = {
            "Content-Type": "application/json",
        };

        axios.get(ContactTypes, { headers }).then((response) => {
            setLoading(false);

            if (response.status === 200) {
                setContactType(response.data.data)
                setLoading(false);
            }
        },
        (error) => {
            setLoading(false);
        });     
    }

    useEffect(() => {
        getContactTypeRequestApi();

    }, []);

	const onChangeFirstName = (e) => {
		setFirstName(e.target.value);
	}

	const onChangeLastName = (e) => {
		setLastName(e.target.value);
	}

	const onChangeEmail = (e) => {
		setEmail(e.target.value);
	}

	const onChangeCompanyName = (e) => {
		setCompanyName(e.target.value);
	}

	const onChangeMessage = (e) => {
		setMessage(e.target.value);
	}

	const onChangePhone = (e) => {
		setPhone(e.target.value);
	}

	const onChangeType = (e) => {
		if(e && e.value) {
			setType(e.value);
		}
	}

	const options = () => {
		if(contactTypes.length) {
			return (contactTypes.map((data, index) => {
				let res = {};
				if(data.label !== 'All') {
					res = {
						label:data.label,
						value:data.value,
					}
				}
				return res;
			}));
		}

	}

	const mystyle = {
		option: (provided, state) => ({
			...provided,
			padding: '6px 15px',
			backgroundColor: '#fff !important',
			color: '#000',
			fontSize: '16px',
		  }),
		  control: () => ({
			border: '1px solid #A4A4A4 ',
			color: '#000',
			fontSize: '16px',
			padding: '8px 15px',
			backgroundColor: '#fff !important',
			width: '100%',
			borderRadius: '5px',
			paddingRight: '34px',
		  }),
		  indicatorsContainer: () => ({
			position:'absolute',
			right:'0',
			top:'6px',
			color:'#A4A4A4'
		  }),
	};

	const resetState = () => {
		setLoading(false);
		setFirstName("");
		setLastName("");
		setEmail("");
		setCompanyName("");
		setMessage("");
		setType("");
		setPhone("");
		setFirstNameErr("");
		setLastNameErr("");
		setCompanyNameErr("");
		setEmailErr("");
		setPhoneErr("");
		setTypeErr("");
		setMessageErr("");
	}

	const submit = async (e) => {
		setLoading(true);
		let formData = new FormData();
		formData.append('first_name', firstName);
		formData.append('last_name', lastName);
		formData.append('email', email);
		formData.append('phone', phone);
		formData.append('company_name', companyName);
		formData.append('type', type);

		formData.append('message', message);
		axios.post(ContactUsEndpoint, formData, { headers: {
			'Content-Type': 'multipart/form-data',  "Accept": "application/json" }
		})
		.then((response) => {
			resetState();
			router.push('/thank-you')

		},
		(error) => {
			e.preventDefault();
			setLoading(false);

			if(error.response.status === 412) {
				let validationErrs = error.response.data.validation_error;
				setFirstNameErr(validationErrs.first_name);
				setLastNameErr(validationErrs.last_name);
				setCompanyNameErr(validationErrs.company_name);
				setEmailErr(validationErrs.email);
				setPhoneErr(validationErrs.phone);
				setTypeErr(validationErrs.type);
				setMessageErr(validationErrs.message);

			} else {
				setError(error.response.data.message)
			}
		});
	}
	  
	return (
		<>
			<Head>
				<meta name="keywords" content={meta ? meta.keywords : ''} />
				<title>{meta ? meta.title : ''}</title>
				<meta name="description" content={meta ? meta.description : ''} />
				<link rel="canonical" href={process.env.NEXT_PUBLIC_APP_URL + router.asPath} />
			</Head>
			<div className="banner_breadcrumb_section" id="contact">
				<Container fluid="xl">
					<h1 className="main-heading-lg">Contact Us</h1>
				</Container>
			</div>
		
		<div className="contact-boxs">
			<Container fluid="xl">
				<Row>
					<Col sm={12}  lg={12}>
						<h2>Contact Information	</h2>
						<p className="description-text text-center">Want to speak with a human? <br/> Fill out the contact form or use any of the methods below to reach us.</p>
					</Col>
				</Row>
			</Container>
		<Container fluid="xl">
			<Row>
				<Col sm={12}  lg={12}>
				</Col>
				<Col sm={6}  lg={3}>
					<div className="content-inner-box">
					<div className="icons-set">
					<i className="fas fa-map-marker-alt"></i>
					</div>
					<div className="content-address">
					<p>1362 Central Pkwy, Mississauga, Ontario(ON), L5C 3T6</p>
					</div>
					</div>
				</Col>
				<Col sm={6}  lg={3}>
					<div className="content-inner-box">
					<div className="icons-set">
					<i className="far fa-envelope"></i>
					</div>
					<div className="content-address">
					<p>Email Us: </p> 
					<p><a href="mailto:loremipsum@toprow.ca">loremipsum@toprow.ca</a></p>
					</div>
					</div>
				</Col>
				<Col sm={6}  lg={3}>
					<div className="content-inner-box">
					<div className="icons-set">
					<i className="far fa-phone-alt"></i>
					</div>
					<div className="content-address">
					<p>Call Us: </p>
					<p><a href="tel:123-456-7890">123-456-7890</a></p>
					</div>
					</div>
				</Col>
				<Col sm={6} lg={3}>
					<div className="content-inner-box">
					<div className="icons-set">
					<i className="fal fa-clock"></i>
					</div>
					<div className="content-address">
					<p><span>Monday - Friday</span> <br/>
					9AM - 5PM EST</p>
					</div>
					</div>
				</Col>
			</Row>
		</Container>
		</div>    
		<div className="getin-touch-section">
			<div className="custom-container">
				<Container>
					<Row>
						<Col sm="12" className="contact-form">
							<div className="contact-wrap"> 
								<div className="contact-wrap-left">
									<div className="contact-image">
										<div className="get-texts">
										<h3>Get in Touch With Us</h3>
										<p>Get in touch with us anytime, we&#39;re always 
										here to help! Fill out the form to send us 
										a message.</p>
										</div>
									</div>
								</div>
								<div className="contact-wrap-right">
									<div className="contact-form-area">
										<Form>
											<FormGroup row className='form-group'>
												<Col sm={6}>
													<Input type="text" name="first_name" id="firstName" placeholder="First Name" className="input_text form-control" onChange={onChangeFirstName} value={firstName}/>
													<span className="text-danger">{firstNameErr}</span>
												</Col>
												<Col sm={6}>
													<Input type="text" name="last_name" id="last_name" placeholder="Last Name" className="input_text form-control" onChange={onChangeLastName} value={lastName}/>
													<span className="text-danger">{lastNameErr}</span>
												</Col>
											</FormGroup>
											<FormGroup row className='form-group'>
												<Col sm={12}>
													<Input type="text" name="company_name" id="company_name" placeholder="Company Name" className="input_text form-control" onChange={onChangeCompanyName} value={companyName}/>
													<span className="text-danger">{companyNameErr}</span>
												</Col>
											</FormGroup>
											<FormGroup row className='form-group'>
												<Col sm={6}>
													<Input type="email" name="email" id="email" placeholder="Email" className="input_text form-control" onChange={onChangeEmail} value={email}/>
													<span className="text-danger">{emailErr}</span>
												</Col>
												<Col sm={6}>
													<Input type="text" name="phone" id="phone" placeholder="Phone" className="input_text form-control" onChange={onChangePhone} value={phone}/>
													<span className="text-danger">{phoneErr}</span>
												</Col>
											</FormGroup>
											<FormGroup row className='form-group'>
												<Col sm={12}>
													<Select
													name="name"
													placeholder='Choose a Topic'
													isSearchable={true}
													options={options()}
													onChange={onChangeType} 
													styles={mystyle}
													className="input-text"
													/> 
													<span className="text-danger">{typeErr}</span>
												</Col>
											</FormGroup> 
											<FormGroup row className='form-group'>
												<Col sm={12}>
													<Input type="textarea" name="message" id="message" placeholder="Message" className="input_text form-control" onChange={onChangeMessage} value={message}/>
													<span className="text-danger">{messageErr}</span>
												</Col>
											</FormGroup>
											<FormGroup row className='button-submit form-group'>
											<Col sm={{ size: 12, offset: 0 }}>
												<Button className="primary-btn btn btn-secondary" onClick={submit}> <span>Send Message</span>
													{loading 
													? (
													<span className="spinner-border spinner-border-sm ml-5" role="status" aria-hidden="true">
													</span>) 
													: (
														<span></span>
														)
													}</Button>
													<p className="our-team-text">*Our team is available Monday - Friday from 9 am to 5 pm EST</p>
												</Col>
											</FormGroup>
										</Form>
									</div>
								</div>
							</div>
						</Col>  
					</Row>     
				</Container>
			</div>
		</div>	
		</>	
	)
}

// This gets called on every request
export async function getServerSideProps({ req, res}) {
    try {
        const response = await axios.get(process.env.NEXT_PUBLIC_API_URL+'metas?path=/contact-us', { headers: {
            "Accept": "application/json" }
        });

        return { props: { meta: response.data.data,  } }

    } catch (err) {
        const meta = false;

        return { props: { meta } };
    }
}

ContactUs.Layout = PublicLayout;

export default ContactUs
